<template>
  <svg
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    aria-hidden="true"
    class="alice-waveform"
  >
    <rect
      v-for="(h, i) in bars"
      :key="i"
      :x="i * (barWidth + gap)"
      :y="(height - h) / 2"
      :width="barWidth"
      :height="h"
      fill="currentColor"
    />
  </svg>
</template>

<script>
function hashString(str) {
  let h = 5381;
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) + h + str.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

function pseudoRandomBars(seed, count, minH, maxH) {
  const out = [];
  let s = hashString(seed) || 1;
  for (let i = 0; i < count; i++) {
    s = (s * 1103515245 + 12345) & 0x7fffffff;
    const r = (s % 1000) / 1000;
    out.push(minH + Math.round(r * (maxH - minH)));
  }
  return out;
}

export default {
  name: "AliceWaveform",
  props: {
    seed: { type: String, default: "" },
    width: { type: Number, default: 220 },
    height: { type: Number, default: 28 },
    barCount: { type: Number, default: 40 },
    barWidth: { type: Number, default: 2 },
    gap: { type: Number, default: 3 },
    minHeight: { type: Number, default: 4 },
    maxHeight: { type: Number, default: 24 },
  },
  computed: {
    bars() {
      return pseudoRandomBars(
        this.seed || "alice",
        this.barCount,
        this.minHeight,
        Math.min(this.maxHeight, this.height)
      );
    },
  },
};
</script>

<style scoped>
.alice-waveform {
  display: block;
  color: var(--fg-3);
  flex-shrink: 0;
}
</style>
